import { createQueryKeyFactory } from '@/utils/queries'

export default createQueryKeyFactory(['personsById'])
